export function addEventListener(event, fun, options) {
  const opts = {}
  if (options.capture[0] !== undefined) opts.capture = options.capture[0]
  if (options.once[0] !== undefined) opts.once = options.once[0]
  if (options.passive[0] !== undefined) opts.passive = options.passive[0]
  if (options.signal[0] !== undefined) opts.signal = options.signal[0]
  return document.addEventListener(event, fun, opts)
}

export function removeEventListener(event, fun, useCapture) {
  return document.removeEventListener(event, fun, useCapture)
}
